/**
 * Build-time info injected by Vite (see `define` block in vite.config.js).
 *
 * VERSION is `<short-sha>-<iso-minute>Z` and changes on every build.
 * DEPLOY_ENV reflects the deployment target, independent of Vite's build mode:
 *   - 'prod' when CI builds from `main`
 *   - 'qa'   when CI builds from `qa`
 *   - 'dev'  for local builds / `npm run dev`
 */
export const VERSION: string = __APP_VERSION__;
export const DEPLOY_ENV: 'prod' | 'qa' | 'dev' = __DEPLOY_ENV__;
export const IS_PROD = DEPLOY_ENV === 'prod';
